import React from 'react'

import { Box } from '@chakra-ui/react'

import { ColorScheme } from '../../types'

export type ArrowLeftIconProps = {
  /** Explicit color override; takes precedence over `colorScheme`. */
  color?: string
  /** Without either prop the icon inherits `currentColor` from its parent
   * (e.g. UtilityButton), so hover/active states stay in sync. */
  colorScheme?: ColorScheme
  className?: string
  width?: number
  height?: number
}

export const ArrowLeftIcon = ({
  color,
  colorScheme,
  className,
  width = 24,
  height = 24,
}: ArrowLeftIconProps) => (
  <Box
    className={className}
    color={
      color ??
      (colorScheme
        ? colorScheme === 'light'
          ? 'light.icon.secondary'
          : 'icon.secondary'
        : 'currentColor')
    }
    display='inline-flex'
    flexShrink={0}
    height={`${height}px`}
    lineHeight={0}
    width={`${width}px`}
  >
    <svg
      aria-label='Arrow left'
      fill='none'
      height={height}
      role='img'
      viewBox='0 0 24 24'
      width={width}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19 12H5M5 12L12 19M5 12L12 5'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
    </svg>
  </Box>
)
